import React from 'react';

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const secs = (seconds % 60).toFixed(1).padStart(4, '0');
  return `${minutes}:${secs}`;
};

const PlayheadController = ({ 
  isPlaying, 
  currentVideoTime, 
  sessionDuration, 
  onPlayPause, 
  onPlayheadChange 
}) => {
  return (
    <div className="master-playhead" style={{
      background: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '4px',
      padding: '12px',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }}>
      <button 
        onClick={onPlayPause}
        style={{
          background: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          padding: '8px 12px',
          cursor: 'pointer'
        }}
      >
        {isPlaying ? 'Pause' : 'Play'}
      </button>
      <span style={{ fontSize: '12px', minWidth: '60px' }}>
        {formatTime(currentVideoTime)}
      </span>
      <input
        type="range"
        min="0"
        max={sessionDuration || 100}
        step="0.1"
        value={currentVideoTime}
        onChange={(e) => onPlayheadChange(parseFloat(e.target.value))}
        style={{
          flex: 1,
          height: '6px',
          background: '#ddd',
          borderRadius: '3px',
          outline: 'none'
        }}
      />
      <span style={{ fontSize: '12px', minWidth: '60px' }}>
        {formatTime(sessionDuration || 0)}
      </span>
    </div>
  );
};

export default PlayheadController;